export const CACHE_KEYS = {
  CLIENT_INFORMATION: "ClientInformation",
  CLEANING_DATA: "CleaningData",
  MANUAL_CLEANING_DATA: "ManualCleaningData",
  WEEDING_DATA: "WeedingData",
  WEEDING_AUDIT_DATA: "WeedingAuditData",
  ENABLED_CLIENT_INFORMATION: "EnabledClientInformation",
  DASHBOARD_DATA: "DashboardData",
  CLAIM_DATA_BY_YEAR: "ClaimInformation",
} as const;

export type CacheKey = (typeof CACHE_KEYS)[keyof typeof CACHE_KEYS];
